var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"couClock"},[_c('p',{staticClass:"couClock_date"},[_vm._v(_vm._s(_vm._f("formatYmdDot")(_vm.time)))]),_c('p',{staticClass:"couClock_time"},[_vm._v(_vm._s(_vm._f("formatHmsColon")(_vm.time)))])])}
var staticRenderFns = []

export { render, staticRenderFns }